import type { FC } from 'react'

import { Skeleton } from '@skytech/ui'
import { useQuery } from '@tanstack/react-query'

import { Translation } from '@/app/translations/Translation'
import queries from '@/modules/ecom-policy/queries'
import ecomPolicyResources from '@/modules/ecom-policy/resources'
import { numberFormat } from '@/util/formatters/numbers'

import { usePolicyId } from '../hooks'

import './bullet-points.scss'

const BulletPoints: FC = () => {
  const policyId = usePolicyId()

  const { data: policy } = useQuery(queries.policyDetails(policyId), () =>
    ecomPolicyResources.getPolicyDetails(policyId)
  )
  const policyPoductsQuery = useQuery(queries.policyProducts(policyId), () =>
    ecomPolicyResources.getPolicyProducts(policyId)
  )

  if (!policy) return null

  const { customerName, customerHeadName, priceListName, subscriberCount } = policy
  const selectedProducts = policyPoductsQuery.data?.products.filter(
    ({ isSelected }) => isSelected === 1
  ).length

  return (
    <div className="ecom-policy-bullet-points">
      {customerName && (
        <div>
          <Translation id="Local" /> <em>{customerName}</em>
        </div>
      )}

      {customerHeadName && (
        <div>
          <Translation id="Global" /> <em>{customerHeadName}</em>
        </div>
      )}

      <div>
        <Translation id="Price List" /> <em>{priceListName}</em>
      </div>

      <div>
        <Translation id="Products" />{' '}
        <em>
          {/* check why -1 */}
          {policyPoductsQuery.isLoading ? (
            <Skeleton />
          ) : (
            <>
              {numberFormat(selectedProducts, -1)} <Translation id="of" />{' '}
              {numberFormat(policyPoductsQuery.data?.products.length, -1)}
            </>
          )}
        </em>
      </div>

      <div className="subscribers">
        <Translation id="Subscribers" /> <em>{numberFormat(subscriberCount)}</em>
      </div>
    </div>
  )
}

export default BulletPoints
